import React, { useEffect, useState } from "react";

const STORAGE_KEY = "spotie-cookie-consent";

const fireConsentUpdate = (decision) => {
  // gtag is defined in public/index.html via the Consent Mode default snippet.
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  const value = decision === "granted" ? "granted" : "denied";
  window.gtag("consent", "update", {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      // SSR / private mode: just show the banner.
    }
    if (stored === "granted" || stored === "denied") {
      // Re-fire the saved decision so consent state matches the user's
      // prior choice on every page load (default starts at 'denied').
      fireConsentUpdate(stored);
      return;
    }
    setVisible(true);
  }, []);

  const decide = (decision) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, decision);
    } catch (e) {
      // ignore storage failures, still update consent for this session
    }
    fireConsentUpdate(decision);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-text">
        We use cookies to analyze site usage and improve your experience. You
        can accept all cookies or decline non-essential ones.
      </div>
      <div className="cookie-banner-actions">
        <button
          type="button"
          className="cookie-banner-btn decline"
          onClick={() => decide("denied")}
        >
          Decline
        </button>
        <button
          type="button"
          className="cookie-banner-btn accept"
          onClick={() => decide("granted")}
        >
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
